import { render, staticRenderFns } from "./MarketNav.vue?vue&type=template&id=23559796&scoped=true"
import script from "./MarketNav.vue?vue&type=script&lang=js"
export * from "./MarketNav.vue?vue&type=script&lang=js"
import style0 from "./MarketNav.vue?vue&type=style&index=0&id=23559796&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23559796",
  null
  
)

export default component.exports